import { render } from "./bindUser.vue?vue&type=template&id=802f7e7e&scoped=true"
import script from "./bindUser.vue?vue&type=script&lang=js"
export * from "./bindUser.vue?vue&type=script&lang=js"

import "./bindUser.vue?vue&type=style&index=0&id=802f7e7e&lang=less&scoped=true"

import exportComponent from "D:\\New Git\\tl-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-802f7e7e"]])

export default __exports__